<template>
  <div class="main-template">
    <!-- resourceVBind:{{ resourceVBind }} -->
    <v-dialog v-model="popupVisible" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Event Details</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="popupVisible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-html="popupContent"></v-card-text>
      </v-card>
    </v-dialog>
    <v-cal-tbl-map
      :reload="reload"
      :expansionColumns="expansionColumns"
      :eventClick="eventClick"
      :customDayClick="customDayClick"
      :eventTemplate="eventTemplate"
      :getItemColor="getItemColor"
      :coloredFields="['pickup_status', 'agent', 'status', 'delievery_status']"
      :tableKey="tableKey"
      :onDataReceived="onDataReceived"
      :activeTab="activeTab"
      :noDelete="true"
      :selectSwitch="false"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :mapTitle="mapTitle"
      :tableName="tableName"
      :mapReady="mapReady"
      :mapData="mapData"
      :mapLegend="mapLegend"
      :editable="editable"
      :onMarkerClick="onMarkerClick"
      :onMarkerDrop="onMarkerDrop"
      :showGroupBy="false"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :updateTable="updateTable"
      :isDraggable="tableDraggable"
      :objKey="objKey"
      :mapLoading="mapLoading"
      :onLegendSelection="onLegendSelection"
      :hasAdvancedSearch="true"
      :toolBarControls="toolBarControls"
      :filterTabs="filterTabs"
      :calToolBarControls="calToolBarControls"
      defaultTabCaption="Select Status"
      :itemsPerPage="itemsPerPage"
      :hideAllTabFilter="false"
      filterComboLabel="Select Status"
      :defaultTab="activeTab"
      :showFullTable="showFullTable"
      :key="objKey"
      :resourceVBind="resourceVBind"
      :dataTemplate="dataTemplate"
      :calendarFilter="calendarFilter"
      :dayClickFilter="dayClickFilter"
      :defaultType="defaultType"
      :summaryTemplate="summaryTemplate"
      :categoryTemplate="categoryTemplate"
      :categoryName="categoryName"
      :categoryDays="categoryDays"
      :eventHeight="eventHeight"
      :mapWidth="mapWidth"
      tableTabTitle="All Scheduled Jobs"
      :activeTabChanged="activeTabChanged"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";

export default {
  name: "LDDispatch",
  components: {
    // VCombo: () => import("../components/ComboBox.vue"),
    VCalTblMap: () => import("../components/CalTblMap.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    VCrew: () => import("../components/Crew.vue"),
  },
  props: {},
  data() {
    return {
      itemsPerPage: 10,
      calType: "",
      defaultType: "",
      estimateKey: "",
      itineraryKey: "",
      categoryName: "Foremen",
      unfilteredResources: null,
      eventHeight: 0,
      categoryDays: 7,
      objKey: 0,
      activeTab: 0,
      mapTitle: "Map",
      showFullTable: false,
      tableName: "lddispatch",
      curAgent: {},
      dayCrews: [],
      defaultEventColor: "#137C15FF",
      data_object: null,
      // activeTab: 0,
      dateField: "date",
      heightValue: "inherit",
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      mapData: [],
      dataTable: [],
      shipments: [],
      dateFrame: null,
      expansionColumns: 6,
      mapWidth: 0,
      // filterTabs: [
      //   {
      //     name: "pickup_status",
      //     value: "booked",
      //     caption: "Booked",
      //     color: "blue",
      //   },
      //   {
      //     name: "pickup_status",
      //     value: "!booked",
      //     caption: "Scheduled",
      //     color: "green",
      //   },
      // ],
      popupVisible: false,
      popupContent: "",
      showCrews: false,
      objCal: null,
      fullMapData: [],
      mapLegend: {
        data_object: {
          object_name: "v_day_crew",
          qry: {},

          get_table: "all",
        },
        getFreshData: true,
        mobileBreakpoint: 0,
        keyName: "crew_resources",
        // foreman: [],
        pickup_status: [],
        agent: [],
        dispatcher: [],
        serviceCategory: [],
        serviceType: [],
        all_records: true,
        table_title: "Crews",
        // tableName: "foreman",
        hasSearch: true,
        fields_included: ["employee_id", "full_name"],
        noTabs: true,
        hideHeader: true,
        singleSelect: true,
        coloredFields: ["employee_id", "confirmed"],
        getItemColor: function(e, slot, item, tableName) {
          return item.color;
        },
        width: 3,
      },
      editable: [
        "etd",
        "pickup_status",
        "delivery_status",
        "foreman",
        "warehouse",
        "agent",
        "confirmed",
      ],
      agentCombo: {
        label: "Agent",
        objName: "agent",
        itemText: "contact.company",
        itemValue: "_id",
        // itemColor: "color",
        defaultIndex: -1,
        returnObject: true,
        ctlName: "curAgent",
        // width: "290px",
        // height: "350px",
      },
      tableDraggable: true,
      toolBarControls: [],
      calToolBarControls: [],
      showAgentsList: 0,
      showDispList: 0,
      unassignedOnly: true,
      table: null,
      permittedActions: null,
      currentUser: "",
      agentFilter: false,
      foremanFilter: false,
      agentComboKey: 0,
      agentCrewKey: 0,
      curDispatcher: null,
      customerQry: null,
      serviceQry: null,
      assignLabel: "Please select records to assign ",
      assignInitialLabel: "Assign ",
      isDispatcherAssign: false,
      isExternalDispatch: false,
      updatedItems: [],
      menuItems: [
        // { itemText: "Crew", itemValue: "crew" },
        { itemText: "Agent", itemValue: "agent" },
      ],
      crewModel: {
        crew: {},
      },
      resourceType: null,
      categoryTemplate:
        "let categories=['Unassigned'];let foremen=data.additional_model.v_foreman; foremen.forEach(f=>{categories.push(f.contact.first_name+' '+f.contact.last_name)});  categories",
      resourceVBind: {
        hasDefaultResources: true,
        dataTitle: "shipment_id",
        time: [
          { value: "all day", start: 0, end: 24 },
          { value: "morning", start: 0, end: 12 },
          { value: "afternoon", start: 12, end: 18 },
          { value: "evening", start: 18, end: 24 },
        ],
        timeName: "etd",
        resourceName: "Crews",
        dataName: "Unassigned Jobs",
        scheduledDataName: "Assigned Jobs",
        addBtnTitle: "Add Crew",
        resourceTitle: "full_name",
        dataResource: "day_crew",
        resourceLink: {
          field: "employee_id",
          name: "employee",
        },
        calModelKey: 0,
        calModel: null,

        resourceLinkClick: function(item) {
          this.$root.addResentTab(item);
        },
        // resourceTemplate: function(d) {
        //   var template = `
        //    <b>${d.crew_name}</b>   `;

        //   //        <b>${d.contact ? d.contact.first_name : d.first_name} ${
        //   //     d.contact ? d.contact.last_name : d.last_name
        //   //   }</b>
        //   //  <b>${d.contact && d.contact.company ? d.contact.company : ""}</b>
        //   //  <br/>
        //   //   Mobile: ${
        //   //     d.contact.phones && d.contact.phones.mobile
        //   //       ? d.contact.phones.mobile.phone_number || d.contact.phones.mobile
        //   //       : ""
        //   //   }

        //   return template;
        // },
        link: "shipment_id",
      },
      // filterTabsFn: {
      //   "v-bind": {
      //     objName: "company",
      //     caption: "company_name",
      //     value: "company_name",
      //     name: "company",
      //     color: "color",
      //     filterProperty: "company_name",
      //   },
      // },
    };
  },
  mounted() {
    var that = this;
    this.mapWidth = window.innerWidth + 0.6;
    // this.table = this.getTable();
    this.permittedActions = this.$root.store.permittedActions;
    window.openTab = function(id) {
      let item = that.shipments.find((e) => {
        return e._id == id;
      });
      if (!item) {
        item = id;
      }

      that.$root.addResentTab(item);
    };
    window.customDayClick = this.customDayClick;
    window.resourcesAsTable = this.resourcesAsTable;
    window.openPopup = this.openPopup;

    this.defaultType =
      this.$root.portal_settings[0].default_calendar_interval || "month";
    // this.$root.portal_settings[0].default_calendar_interval ||
    this.currentUser = this.$root.store.userData.email;
    if (
      this.permittedActions.some((a) => {
        return a.filter_jobs;
      })
    ) {
      // this.agentFilter = true;
      if (this.$root.roles.some((role) => role.toLowerCase() === "foreman")) {
        this.foremanFilter = true;
      }
      if (this.$root.roles.some((role) => role.toLowerCase() === "agent")) {
        this.agentFilter = true;
      }
    }
    this.isExternalDispatch = this.$root.roles.some(
      (role) => role.toLowerCase() === "external_dispatcher"
    );
    this.$root.$on("comboUpdated", (c) => {
      // console.log(c);
      if (c.ctlName == "curAgent") {
        this.filterAgents(c);
      }
    });
    this.$root.$on("tableMounted", (c) => {
      // console.log(c);
      // if (c.tableName == "lddispatch") {
      //   this.filterAgents();
      // }
    });
    this.$root.$on("customBtnClick", (f) => {
      if (f.id == "assign") {
        that.showAgents(f.item);
      }
      if (f.btn == "cancelAssign") {
        that.showAgents(f.item);
      }
      //that.toolBarControls[4]["v-bind"].hidden = !that.showAgentsList
      // if (f.btn == "assignDisp") {
      //   that.showDisp();
      // }
      //assignDisp
      if (f.btn == "rejectJobs") {
        that.rejectJobs();
      }
    });
    // <v-combo
    //     class="ml-2"
    //     v-model="curAgent"
    //     v-if="!agentFilter"
    //     v-bind="agentCombo"
    //   ></v-combo>
    this.calToolBarControls = [
      //
      // {
      //   comp: "v-date-field",
      //   id: "calModel",
      //   key: this.calModelKey,
      //   hidden: false,
      //   types: ["month", "day", "week"],
      //   show: true,

      //   model: this.calModel
      // },
      {
        comp: "v-combo",
        id: "curAgent",
        key: this.agentComboKey,
        hidden: false,
        types: ["month", "day"],
        show: true,

        model: this.curAgent,
        "v-bind": this.agentCombo,
      },
      {
        comp: "v-combo",
        id: "customer_filter",
        types: ["week", "month", "day"],
        show: true,
        // model: this.agent,
        "v-bind": {
          label: "Customer Filter",
          itemText: "customer_name",
          itemValue: "customer",
          items: [],
          multiple: true,
          onValueChange: this.filterCustomers,

          clearable: true,
        },
      },
      {
        comp: "v-combo",
        id: "service_filter",
        types: ["week", "month", "day"],
        show: true,
        // model: this.agent,
        "v-bind": {
          label: "Service Filter",
          itemText: "service_category",
          itemValue: "service_category",
          items: [],
          multiple: true,
          onValueChange: this.filterService,

          clearable: true,
        },
      },
    ];
    if (!this.isExternalDispatch) {
      this.menuItems.push({
        itemText: "External Dispatcher",
        itemValue: "external_dispatcher",
      });
    }
    this.toolBarControls = [
      {
        comp: "v-menu-button",
        // hidden: !this.unassignedOnly,

        id: "assign",
        default: false,
        "v-bind": {
          color: "success",
          text: true,
          title: this.showAgentsList
            ? this.assignLabel
            : this.assignInitialLabel,
          menuItems: this.menuItems,
          icon: "mdi-account-outline",
          // "input-value": this.showAgentsList
          //   ? this.assignLabel
          //   : this.assignInitialLabel,
        },
      },
      // {
      //   comp: "v-crew",
      //   id: "crew",
      //   key: this.agentCrewKey,
      //   "v-bind": { vModel: this.crewModel },

      // },
      {
        comp: "v-combo",
        id: "agents",
        hidden:
          !this.showAgentsList ||
          (this.showAgentsList && this.isDispatcherAssign),
        model: this.agent,
        "v-bind": {
          label: "Assign Agent",
          objName: "agent",
          itemText: "contact.company",
          itemValue: "_id",
          onValueChange: this.assign,
          returnObject: true,
          clearable: true,
        },
      },

      {
        comp: "v-combo",
        id: "externalDisp",
        hidden: !this.showAgentsList || !this.isDispatcherAssign,
        // model: this.agent,
        "v-bind": {
          objName: "v_external_dispatcher",
          label: "Assign External Dispatcher",
          itemText: "full_name",
          itemValue: "_id",
          onValueChange: this.assign,
          returnObject: true,
          clearable: true,
        },
      },
      {
        comp: "div",

        id: "labAssign",
        value: "assign",
        hidden: true,
        "v-bind": {
          value: "assign",
        },
      },
      {
        comp: "v-btn",
        // hidden: true,
        id: "cancelAssign",
        text: true,
        small: true,
        "v-bind": {
          // color: "warning",
          text: true,
          small: true,
          hidden: true,
          icon: "mdi-cancel",
          "input-value": "Cancel",
        },
      },

      // {
      //   comp: "v-switch",
      //   id: "unassignedOnly",

      //   "v-bind": {
      //     label: "Unassigned Only",
      //     class: "pt-4",
      //   },

      //   model: this.unassignedOnly,
      // },
    ];
    this.$root.$on("tableSelectionChanged", (t) => {
      if (t.tableName == "lddispatch") {
        // that.toolBarControls[1].hidden = !t.selected.length;
        that.ctl("assign").hidden = that.showAgentsList;
        that.ctl("labAssign").hidden = t.selected.length > 0;
        // if (that.ctl("agents")) {
        //   that.ctl("agents").hidden = !t.selected.length;
        //   that.ctl("agents")["v-bind"]["input-value"] =
        //     "Reject Selected Jobs";
        // }
        var btnLabel = !t.selected.length
          ? that.showAgentsList
            ? that.assignLabel
            : that.assignInitialLabel
          : "Select Agent for " + t.selected.length + " job(s)";
        that.ctl("assign")["v-bind"]["input-value"] = btnLabel;
        that.ctl("externalDisp").hidden = !t.selected.length ? false : true;
        that.ctl("labAssign")["v-bind"].hidden = !that.showAgentsList;
        that.ctl("agents").hidden =
          !t.selected.length || that.isDispatcherAssign;
        that.ctl("externalDisp").hidden =
          !t.selected.length || !that.isDispatcherAssign;
      }
      // console.log(t);
    });
    this.$root.$on("tableItemChanged", (t) => {
      if (!t.tbl.tableName && !t.tbl.objectName) {
        return;
      }

      var curRec = that.dataTable.filter((r) => {
        return r._id == t.item._id;
      })[0];

      // that.updateLdPickup(t, curRec);
    });
    // this.getDataObject();
  },
  beforeDestroy() {},
  methods: {
    openPopup(id) {
      // Find the event data by shipmentId (replace with your actual logic)

      // Set the content for the modal
      // const cal = this.objCal.$refs.calendar;
      var e = this.shipments.find((s) => {
        return s._id == id;
      });
      this.popupContent =
        "<div class='popup-instructions'><h3>" +
        e.customer_name +
        "</h4>" +
        e.special_instructions +
        "</div>";

      // Open the popup
      this.popupVisible = true;
    },
    createQry(r, type, qry, emptyQry) {
      this.objCal = this.$refs.calTblMap;
      const cal = this.objCal.$refs.calendar;

      if (!this.objCal.activeTab && !r.value.length && this[type]) {
        this[type] = {};
        return;
      }
      if (
        !this.objCal.activeTab &&
        ((!this[type] && !r.value) || !r.value.length)
      ) {
        return;
      }

      if (!this.objCal.activeTab) {
        if (!r || !r.value) {
          this[type] = null;
        } else {
          this[type] = qry(r);
        }
        // console.log(r);

        // cal.refresh();

        cal.refresh = true;
        cal.getEvents(this.dateFrame, true);
      } else {
        const custFilter = this.objCal.$refs.customer_filter[0].model;
        const servFilter = this.objCal.$refs.service_filter[0].model;

        if (!this.unfilteredResources) {
          this.unfilteredResources = fun.clone(this.resourceVBind);
        }
        var filterFunction = function(f) {
          if (!custFilter.length && !servFilter.length) {
            return true;
          } else {
            var include = true;

            if (custFilter.length) {
              include = f["customer_id"].includes(custFilter);
            }
            if (servFilter.length && include) {
              include = f["service_category"].includes(servFilter);
            }

            return include;
          }
        };
        this.resourceVBind.filteredDataRecords = fun.clone(
          this.resourceVBind.data.filter((f) => {
            if (!custFilter.length && !servFilter.length) {
              return true;
            } else {
              var include = true;

              if (custFilter.length) {
                include = custFilter.includes(f["customer_id"]);
              }
              if (servFilter.length && include) {
                include = servFilter.includes(f["service_category"]);
              }

              return include;
            }
          })
        );
        this.resourceVBind.filteredDataRecords.sort((a, b) => {
          // Compare the crew names alphabetically
          return b.itinerary.load_order > a.itinerary.load_order;
        });

        // this.mapData = [];

        // this.resourceVBind.filteredDataRecords.forEach((r) => {
        //   this.createPickupMapData(r);
        // });
        if (!this.fullMapData.length) {
          this.fullMapData = fun.clone(this.mapData);
        }
        this.mapData = fun.clone(
          this.fullMapData.filter((obj1) => {
            return this.resourceVBind.filteredDataRecords.some(
              (obj2) => obj1._id === obj2._id
            );
          })
        );
        var dMap = this.objCal.$refs.hereMap;
        if (dMap) {
          dMap.mapData = this.mapData;
          dMap.initMap();
        }
        if (this.objCal) {
          // this.objCal.dataTable = this.resourceVBind.filteredDataRecords;

          // this.objCal.tableKey = !this.objCal.tableKey;
          var dTable = this.objCal.$refs.dTable;
          if (dTable) {
            dTable.table = this.resourceVBind.filteredDataRecords;
            dTable.itemsCount = this.resourceVBind.filteredDataRecords.length;
          }
        }
        this.resourceVBind.filteredResources = this.resourceVBind.resources.filter(
          (obj1) =>
            this.resourceVBind.filteredDataRecords.some(
              (obj2) => obj2.day_crew && obj1._id === obj2.day_crew._id
            )
        );
        if (this.objCal) {
          this.objCal.resourceKey = !this.objCal.resourceKey;
        }
        //
      }
    },
    filterService(r) {
      if (!this.serviceType) {
        return;
      }
      // console.log(this.serviceType);
      // const filteredServiceCategories = this.serviceCategory.map(
      //   (obj) => obj.service_category
      // );
      this.createQry(
        r,
        "serviceQry",
        (r) => {
          return {
            service_category: {
              $in: r.value,
            },
          };
        },
        (s) => {
          return s.service_type == r.value;
        }
      );
    },
    filterCustomers(r) {
      this.createQry(
        r,
        "customerQry",
        (r) => {
          return {
            customer_id: {
              $in: r.value,
            },
          };
        },
        (s) => {
          return s.customer_id == r.value;
        }
      );

      // if (!r.value.length && this.customerQry) {
      //   this.customerQry = {};
      //   return;
      // }
      // if ((!this.customerQry && !r.value) || !r.value.length) {
      //   return;
      // }

      // this.objCal = this.$refs.calTblMap;
      // if (!this.objCal.activeTab) {
      //   if (!r || !r.value) {
      //     this.customerQry = null;
      //   } else {
      //     this.customerQry = {
      //       customer_id: { $in: r.value },
      //     };
      //   }
      //   // console.log(r);

      //   // cal.refresh();
      //   var cal = this.objCal.$refs.calendar;
      //   cal.refresh = true;
      //   cal.getEvents(this.dateFrame, true);
      // } else {
      //   if (!this.unfilteredResources) {
      //     this.unfilteredResources = fun.clone(this.resourceVBind);
      //   }
      //   this.dataTable = this.unfilteredResources;
      //   this.dataTable = this.dataTable.filter((s) => {
      //     return s.customer_id == r.value;
      //   });
      //   //
      // }
    },
    activeTabChanged(tab) {
      console.log(tab);
      if (tab == 2) {
        this.getGeo();
      }
    },
    customDayClick(d, obj) {
      if (!obj || obj.cal.type == "week") {
        if (!obj) {
          obj = this.$refs.calTblMap;
          obj.calModel = d;
          var cal = obj.$refs.calendar;
          this.showCrews = true;
          this.objCal = obj;
          cal.getEvents({ start: d, end: d }, "", true, true, null, true);
        } else {
          obj.calModel = d;
        }

        return false;
      }
      return true;
    },
    resourcesAsTable(d) {
      var resourceData = [];
      this.makeResourceTable(d, resourceData);
      if (resourceData.length) {
        return this.makeResourceMap(resourceData, d);
      } else {
        return "";
      }

      // return this.generateResourceHTMLTable(resourceData);
    },
    dataTemplate(d, i) {
      // if (!d.origin_address) {
      //   console.log(d);
      // }
      function show(p) {
        return p ? "display:block" : "display:none";
      }
      if (i || i == 0) {
        if (d.itinerary) {
          if (!d.itinerary.load_order && d.itinerary.load_order != 0) {
            if (d.itinerary.load_order == null) {
              d.itinerary.load_order = 0;
            } else {
              d.itinerary.load_order = i + 1;
            }
            d.itinerary.load_order = i + 1;
            this.resourceVBind.data.find((r) => {
              return r.itinerary._id == d.itinerary._id;
            }).itinerary.load_order = d.itinerary.load_order;
          }
        }
      }
      try {
        const specialInstructions = d.special_instructions || "";
        const shortInstructions =
          specialInstructions.substring(0, 300) +
          (specialInstructions.length > 300 ? "..." : "");

        var scheduledResources = this.resourcesAsTable(d);
        const serviceType = this.serviceType.find((s) => {
          return s.service_type == d.service_type;
        });
        var color = "";
        if (serviceType) {
          color = serviceType.color;
        }
        d.customer_name = d.customer_name.replace("'", "");
        var template = `
      <div data-id='${d.itinerary._id}' class='job elevation-5'>
        ${d.itinerary.load_order || ""}



        <a href="javascript:openTab({shipment_id: '${d.shipment_id +
          "_" +
          d._id}',customer_name: '${d.customer_name}'})"> <b>#${
          d.shipment_id
        }</b></a> <span style="color:${color}"><b>${
          d.service_type
        }</b></span><br/>
         <b>${d.customer_name}</b><br/>



         ${scheduledResources}
         <br>
         ${this.convertDateFormat(d.service_date)}<br>
         ${
           d.origin.address.text
             ? "<b>from: </b>" + d.origin.address.text + "<br>"
             : ""
         }
        ${
          d.destination.address.text
            ? "<b>to: </b>" + d.destination.address.text + "<br>"
            : ""
        }

          <br/>
      <div>
        <div  class="special-instructions tooltip-container">${specialInstructions}


      </div>

          </div>
          `;
        return template;
      } catch (error) {
        return "";
      }
    },
    generateResourceHTMLTable(resources, data) {
      // Start with the opening <table> tag

      var that = this;
      let html =
        '<table class="resource-table" border="1" style="border-collapse: collapse; width: 100%;">';

      // First row: Resources
      html += "<tr>";
      if (resources) {
        resources.forEach((item) => {
          html += `<th  style='background-color:${
            data && data.day_crew ? data.day_crew.color : ""
          }'> ${item.resource}</th>`;
        });
        html += "</tr>";

        // Second row: Quantities
        html += "<tr>";
        resources.forEach((item) => {
          html += `<td>${item.qty}</td>`;
        });
        html += "</tr>";

        // Third row: Reserved for other data (empty for now)
        // html += "<tr>";
        // // var assigned = that.dataTable.filter((d) => {
        // //   return d.day_crew && d.day_crew.resources;
        // // });
        // resources.forEach(item => {
        //   var assignedQty = item.assignedQty || 0;

        //   // if (data) {
        //   //   if (data && data.crew_truck) {
        //   //     assignedQty = data.crew_truck.filter(t => {
        //   //       return t.type == item.resource_type;
        //   //     }).length;
        //   //   }
        //   //   if (data && data.crew_employee && item.resource_type == "mover") {
        //   //     assignedQty = data.crew_employee.length;
        //   //   }
        //   // } else {
        //   //   console.log("item", item);
        //   //   assignedQty = item.assignedQty || 0;
        //   //   console.log("assignedQty", assignedQty);
        //   // }

        //   // if (assigned) {
        //   //   assigned.forEach((a) => {
        //   //     a.day_crew.resources.forEach((rs) => {
        //   //       if (rs.resource_type == item.resource_type) {
        //   //         assignedQty += 1;
        //   //       }
        //   //     });
        //   //   });
        //   // }
        //   // console.log("assignedQty in reserved-cell", assignedQty);
        //   html += "<td class='reserved-cell'>" + assignedQty + "</td>";
        // });
        // html += "</tr>";

        // Close the table tag
        html += "</table>";
      }
      return html;
    },
    makeResourceMap(resourceData, d) {
      var resources = "";
      var summarized = Object.values(
        resourceData.reduce((acc, item) => {
          if (!acc[item.resource]) {
            acc[item.resource] = { resource: item.resource, qty: 0 };
          }
          acc[item.resource].qty += parseInt(item.qty);
          acc[item.resource].assignedQty = item.assignedQty;
          return acc;
        }, {})
      );
      summarized.forEach((s) => {
        var icon = this.resourceType.find((res) => {
          return res.resource_type == s.resource;
        }).icon;
        var resource_category = this.resourceType.find((res) => {
          return res.resource_type == s.resource;
        }).resource_category;
        if (resource_category == "labor") {
          icon = "human-dolly";
        }
        s.resource_type = s.resource;
        if (s.resource_type == "men") {
          icon = "human-dolly";
        }
        if (s.resource_type == "truck") {
          icon = "truck";
        }
        s.resource =
          "<span class='large-icon'><i class='mdi mdi-" +
          icon +
          "'> </i></span> " +
          " ";

        // resources +=
        //   s.qty +
        //   " " +
      });
      resources = this.generateResourceHTMLTable(summarized, d);
      return resources;
    },
    makeResourceTable(dd, resourceData, isSummary) {
      if (dd.resources) {
        // resourceData = dd.resources;
        this.resourceType.forEach((t) => {
          var res = dd.resources.filter((r) => {
            return r.resource_type == t.resource_type;
          });
          if (res.length) {
            if (res[0].qty) {
              var assignedQty = 0;
              // if (dd.day_crew) {
              var existingResource = resourceData.find((d) => {
                return d.resource == t.resource_type;
              });
              if (existingResource) {
                existingResource.qty = res[0].qty;
              }
              if (t.resource_type == "men" && dd.crew_employee) {
                assignedQty = dd.crew_employee.length;
              }
              if (t.resource_type != "men" && dd.resources && dd.crew_truck) {
                assignedQty = dd.crew_truck.filter((c) => {
                  return c.type == t.resource_type;
                }).length;
              }
              // }

              if (existingResource) {
                existingResource.assignedQty = assignedQty;
              } else {
                resourceData.push({
                  resource: t.resource_type,
                  qty: res[0].qty,
                  assignedQty: assignedQty,
                });
              }
            }
          }
        });
      }
    },
    getDayTotals(d, data) {
      var curDate = new Date(d);
      curDate = curDate.getDate();
      // if (data.length) {
      //   console.log(data);
      // }

      // var dayData = data.filter((a) => {
      //   var myD = new Date(a.start);
      //   return myD.getDate() == curDate;
      // });
      // var crewData = this.dataTable.filter((a) => {
      //   var myD = new Date(a.crew_date);
      //   return myD.getDate() == curDate;
      // });
      var formattedDate = fun.formatDate(d);
      var crewData = (this.dayCrews || []).filter((a) => {
        // var myD = new Date(a.crew_date);

        var formattedCrewDate = fun.removeLeadingZeros(a.crew_date);
        return a.crew_date == d || formattedCrewDate == formattedDate;
      });
      // if (crewData.length) {
      //   console.log(crewData);
      // }
      if (this.shipments && this.shipments.length) {
        var dayData = this.shipments.filter((s) => {
          return fun.formatDate(s.date) == formattedDate;
        });
        var jobCount = 0;
        var unassignedCount = 0;
        if (dayData.length) {
          unassignedCount = dayData[0].unassigned_count;
          if (dayData[0].more && dayData[0].more > 0) {
            jobCount = dayData.length + parseInt(dayData[0].more);
          } else {
            jobCount = dayData.length;
          }
        }
        var unassigned = "";
        if (unassignedCount) {
          unassigned =
            '<div class="unassigned-count">' +
            unassignedCount +
            " unassigned</div>";
        }
        var jobResources = [];
        // crewData.forEach((c) => {
        //   console.log(c);
        //   if (c.v_schedule) {
        //     c.v_schedule.forEach((s) => {
        //       // if (s.resources) {
        //       //   jobResources = jobResources.concat(s.resources);
        //       // }
        //       dayData.push(s);
        //     });
        //   }
        // });
        var resources = "";
        var summarized = "";
        var resourceData = [];
        if (crewData.length) {
          crewData.forEach((dd) => {
            // dd.resources = jobResources;
            this.makeResourceTable(dd, resourceData, true);
          });
          resources = this.makeResourceMap(resourceData);
        }

        const t = `        <div class="summary-template"  >

    <a href="javascript:customDayClick('${fun.formatDate(
      d
    )}')"> <h4>${fun.convertDateFormat(
          d
        )} -${jobCount} Jobs</h4>${unassigned}</a>


      ${resources}
        </div>`;
        return t;
        //
      }
    },
    convertDateFormat(d) {
      var formatted = fun.convertDateFormat(d);
      return formatted;
    },
    summaryTemplate(d, data, fromScroll) {
      // console.log(d);
      // if (!fromScroll) {
      var dayTotal = this.getDayTotals(d, data);
      // console.log(d, dayTotal);

      return dayTotal;
      // }
    },
    dayClickFilter() {
      this.filterAgents();
    },
    ctl(id) {
      return this.toolBarControls.find((c) => {
        return c.id === id;
      });
    },
    filterAgents(c) {
      var that = this;
      if (!c && !that.curAgent) {
        return;
      }
      if (c) {
        that.curAgent = c.model;
      }
      var cal = this.$refs.calTblMap.$refs.calendar;
      var tableData = that.$refs.calTblMap.tableData;

      if ((that.curAgent && Object.keys(that.curAgent).length) || c.model) {
        cal.events = cal.originalEvents.filter((r) => {
          return r.agent_id == that.curAgent._id;
        });
        try {
          that.$refs.calTblMap.$refs.dTable.table = tableData.filter((r) => {
            return r.agent_id == that.curAgent._id;
          });
        } catch (error) {
          //
        }

        // that.$refs.calTblMap.showFullTable = true;
        // console.log(cal.events);
        // cal.getEvents(cal.dateFrame);
        // cal.calKey = !cal.calKey;
      } else if (cal) {
        cal.events = cal.originalEvents;
        if (that.$refs.calTblMap.$refs.dTable) {
          that.$refs.calTblMap.$refs.dTable.table = tableData;
        }

        // that.$refs.calTblMap.showFullTable = false;

        // this.objKey = !this.objKey;
      }
    },
    showAgents(item) {
      this.table = this.$refs.calTblMap.$refs.dTable;
      this.showAgentsList = !this.showAgentsList;
      if (this.table) {
        this.table.selected = [];
        this.table.select = !this.table.select;
        this.selectRecords = this.table.select;
        this.selectedLength = this.table.selected.length;
      }

      this.ctl("assign").hidden = true;
      this.ctl("labAssign").hidden = false;
      this.ctl("cancelAssign")["v-bind"].hidden = !this.showAgentsList;
      if (item) {
        this.isDispatcherAssign = item.value == "external_dispatcher";

        this.ctl("labAssign").value = this.showAgentsList
          ? this.assignLabel + item.text
          : this.assignInitialLabel + item.text;
      }
    },
    showDisp() {
      // console.log("assign Sales");
      this.table = this.$refs.calTblMap.$refs.dTable;
      this.showDispList = !this.showDispList;
      this.table.selected = [];
      this.table.select = !this.table.select;
      this.selectRecords = this.table.select;
      this.selectedLength = this.table.selected.length;

      // var btnLabel = this.selectRecords
      //   ? "Please select records to assign"
      //   : "Assign External Agents";
      // this.toolBarControls[2]["v-bind"]["input-value"] = btnLabel;
      // this.toolBarControls[3].hidden = true;
    },

    assign(cmb) {
      // this.showAgentsList = !this.showAgentsList;
      if (this.showAgentsList) {
        this.table = this.$refs.calTblMap.$refs.dTable;
        var value = this.isDispatcherAssign ? cmb.value.full_name : cmb.value;
        if (!cmb.value) {
          return;
        }
        // if (cmb.value) {
        var confirmLabel = cmb.value
          ? "Confirm assigning " +
            this.table.selected.length +
            " record(s) to " +
            value +
            "?"
          : "";
        this.$root.$confirm
          .open(confirmLabel, confirmLabel, {
            color: "red",
          })
          .then((confirm) => {
            if (confirm) {
              // var ids = [];
              // table.selected.forEach((r) => {
              //   ids.push(r);
              // });
              // // console.log(r,ids);
              this.doAssign(cmb.value);
              // this.$refs.calTblMap.refresh();
            }
          });
        // }
      }
    },
    rejectJobs() {
      this.table = this.$refs.calTblMap.$refs.dTable;

      //
      this.selectedLength = this.table.selected.length;
      if (!this.selectedLength) {
        this.table.select = !this.table.select;
        this.selectRecords = this.table.select;
      } else {
        var confirmLabel =
          "Confirm rejecting " + this.table.selected.length + " jobs(s) ";
        this.$root.$confirm

          .open(confirmLabel, confirmLabel, {
            color: "red",
          })
          .then((confirm) => {
            if (confirm) {
              //reject jobs
            }
          });
        this.table.selected = [];
        this.table.select = !this.table.select;
        var btnLabel = this.selectRecords
          ? "Please select records to reject"
          : "Reject Jobs";
        this.toolBarControls[2]["v-bind"]["input-value"] = btnLabel;
      }

      // this.toolBarControls[1].hidden = true;
    },
    doAssign(v, _id, crew, res) {
      var data = [];
      var recs = [];
      if (!_id) {
        //items moved to unassigned
        this.table.selected.forEach((r) => {
          if (!this.isDispatcherAssign) {
            r.agent = v;

            if (v) {
              r.pickup_status = "scheduled";
            } else {
              if (!r.foreman) {
                r.pickup_status = "booked";
              }
            }

            data.push(this.updateTableRecord({ item: r }));
            this.table.doTabs();
          } else {
            data.push(this.updateExternalDispather({ item: r, dispatcher: v }));
          }

          recs.push(r.shipment_id);
        });
      } else {
        var rec = this.dataTable.filter((r) => {
          return r._id == _id;
        })[0];
        if (v) {
          rec.day_crew = v;
          rec.pickup_status = "scheduled";
          rec.resources = v.resources;
        } else {
          rec.day_crew = null;
          rec.load_order = null;
          rec.itinerary.day_crew = null;
          rec.itinerary.load_order = null;
          if (!rec.agent) {
            rec.pickup_status = "booked";
            rec.resources = [];
          }
          if (crew) {
            try {
              let crewJobs = this.dataTable
                .filter((r) => {
                  return r.day_crew && r.day_crew._id == crew._id;
                })
                .sort(
                  (a, b) => a.itinerary.load_order - b.itinerary.load_order
                );

              crewJobs.forEach((j, i) => {
                j.itinerary.load_order = i + 1;
              });
              crewJobs.forEach((j, i) => {
                var shipment = this.shipments.find((s) => {
                  return s.itinerary._id == j.itinerary._id;
                });
                data.push({
                  _id: shipment.sid,
                  itinerary_id: j.itinerary._id,
                  update_fields: {
                    load_order: j.itinerary.load_order,
                  },
                });
              });
            } catch (error) {
              //
            }
          }
        }
        // data.push(this.updateTableRecord({ item: rec }));
        data.push({
          update_fields: {
            pickup_status: rec.pickup_status,
            warehouse: rec.warehouse,
            agent: rec.agent,
            load_order: null,
            day_crew: rec.day_crew
              ? {
                  _id: rec.day_crew._id,
                  crew_name: rec.day_crew.crew_name,
                  resources: rec.day_crew.resources.filter((r) => {
                    return r.qty;
                  }),
                }
              : null,
            _id: rec.itinerary._id || fun.guid(),
            etd: rec.etd,
            confirmed: rec.confirmed,
          },
          _id: rec.sid,
          itinerary_id: rec.itinerary._id,
        });
      }

      // this.tableKey = !this.tableKey;

      axios
        .post(this.serverURL + "/update_crew", data, {
          withCredentials: true,
        })
        .then((r) => {
          axios
            .post(
              this.serverURL + "/post_to_app",
              {
                shipment_id: recs,
              },
              {
                withCredentials: true,
              }
            )
            .then((response) => {});
          if (this.table) {
            this.table.selected = [];
          }

          this.showAgents();
          this.agent = "";
          this.successMessage = r.data;
          if (this.curDispatcher) {
            // this.$refs.calTblMap.refresh();
            this.objKey = !this.objKey;
          }
        });
    },

    onLegendSelection(selected, map) {
      console.log(selected, map);
      // switch (this.dispatchType) {
      //   case "ld-pickup":
      var innerElement = document.getElementsByClassName("map-inner"),
        len = innerElement !== null ? innerElement.length : 0,
        i = 0;
      // innerElement[0].classList.remove("highlighted");
      for (i; i < len; i++) {
        // innerElement[i].className = "map-inner";
        innerElement[i].classList.remove("highlighted");
      }
      if (selected && selected.crew_name) {
        var className = selected.crew_name;

        if (className) {
          var highlighted = document.getElementsByClassName(
            className.replace(" ", "-")
          );
          len = highlighted !== null ? highlighted.length : 0;
          i = 0;
          // innerElement[0].classList.add("highlighted");
          for (i; i < len; i++) {
            highlighted[i].classList.add("highlighted");
          }
        }
      }
    },
    updateExternalDispather(t) {
      // var update = { "shipment_detail.external_dispatcher": t.dispatcher };

      // var d = { add: [], update: [], delete: [] };

      // d["update"] = [update];

      // var updateData = { update_data: d };

      var data = {
        metadata: {
          object_name: "shipment",
          update_only: true,
          no_array: true,
        },

        model: {
          _id: t.item.cid,
          "shipment_detail.external_dispatcher": t.dispatcher,
        },
        _id: t.item.cid,
      };
      return data;
    },
    //   var data = {
    //     metadata: { object_name: "shipment", update_only: true },
    //     update: [{ "shipment_detail.external_dispatcher": t.dispatcher }],
    //     model: { _id: t.item.cid },
    //     // _id: t.item.cid,
    //   };
    //   var updateData = {

    //     update_data: t.dispatcher,
    //   };
    //   return data;
    // },
    getRowClass(item) {
      return item.color;
    },
    updateTableRecord(t) {
      this.estimateKey = t.item.estimate_key || "non-binding";
      this.itineraryKey =
        "estimate." +
        this.estimateKey +
        ".shipment_service.$[service].itinerary";
      var itineraryUpdate = {};
      var isNew = false;
      if (t.itemName == "etd") {
        if (t.item.confirmed) {
          t.item.confirmed = false;
        }
      }
      // if (
      //   this.status.some((s) => {
      //     return s.status == "confirmed" && t.item.pickup_status;
      //   })
      // ) {
      //   t.item.pickup_status = "reconfirm";
      // }
      var update = {
        pickup_status: t.item.pickup_status,
        warehouse: t.item.warehouse,
        agent: t.item.agent,
        day_crew: t.item.day_crew
          ? { _id: t.item.day_crew._id, crew_name: t.item.day_crew.crew_name }
          : null,
        _id: t.item.itinerary._id || fun.guid(),
        etd: t.item.etd,
        confirmed: t.item.confirmed,
      };
      // if (t.item.foreman && t.item.foreman.crew) {
      //   update.crew_employee = t.item.foreman.crew.crew_employee;
      //   update.truck = t.item.foreman.crew.truck;
      //   //
      // } else {
      //   update.crew_employee = [];
      //   update.truck = [];
      // }
      if (!t.item.itinerary._id) {
        update["step"] = "d2w";
        itineraryUpdate[this.itineraryKey] = update;
        isNew = true;
        //
      } else {
        Object.keys(update).forEach((k) => {
          itineraryUpdate[this.itineraryKey + ".$." + k] = update[k];
        });
      }

      var d = { add: [], update: [], delete: [] };

      d[isNew ? "add" : "update"] = [update];

      var updateData = {};
      updateData[this.itineraryKey] = {
        id_fields: [
          "_id",
          "estimate." + this.estimateKey + ".shipment_service.itinerary._id",
        ],
        update_data: d,
      };
      updateData[
        "estimate." +
          this.estimateKey +
          ".shipment_service.$[service].itinerary.$[elem]"
      ] = {
        update_data: {
          update: [
            {
              resources: t.item.day_crew ? t.item.day_crew.resources : [],
            },
          ],
        },
      };

      var data = {
        metadata: { object_name: "shipment", update_only: true },
        update: updateData,
        model: { _id: t.item.sid },
        _id: t.item.sid,
      };
      return data;
    },
    updateTable(t, f, jobsInCrew) {
      var that = this;
      var data = this.updateTableRecord(t);

      axios
        .post(this.serverURL + "/add_bulk_data", [data], {
          withCredentials: true,
        })
        .then((r) => {
          if (f) {
            f(r);
          }
          console.log(r.data);
          // this.mapData = [];
          // this.dataTable.forEach((r) => {
          //   this.createPickupMapData(r);
          // });

          this.tableKey = !this.tableKey;
        });
    },
    linkClick: function(item) {
      var shipment = fun.clone(item);
      shipment.text = shipment.name;
      shipment.shipment_id += "_" + item._id;
      this.$root.addResentTab(shipment);
    },

    getItemColor(e, slot, item, tableName) {
      var color = "";
      switch (slot) {
        case "pickup_status":
        case "status":
          if (e) {
            try {
              color = this.status.filter((f) => {
                return f.status == e;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }
          break;
        case "foreman":
          if (e) {
            try {
              color = this.foreman.filter((f) => {
                return f._id == e._id;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }

          break;
        case "warehouse":
          if (e) {
            try {
              color = this.warehouse.filter((f) => {
                return f._id == e._id;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }

          break;
        case "agent":
          if (e) {
            try {
              color = this.agent.filter((f) => {
                return f._id == e._id;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }

          break;
        // case "confirmed":
        //   if (e) {
        //     console.log(e);
        //   }

        //   break;
        // default:
        // break;
      }
      return color;
    },
    crewTemplate(e, data, index) {
      var ev = "";
      var eventColor = e.color;
      var resourceData = [];
      var start = new Date(e.crew_date);
      if (e.day_crew) {
        console.log(e.day_crew);
        e.crew_name = e.day_crew.crew_name;
      }
      var foreman = "";
      if (e.crew_employee) {
        foreman = e.crew_employee.find((c) => {
          return c.employee_role == "foreman";
        });
        if (foreman && foreman.employee) {
          foreman = foreman.employee.full_name;
        } else {
          foreman = "";
        }
      }

      var endTime = start.addHours(2);
      this.makeResourceTable(e, resourceData);

      var resources = this.makeResourceMap(resourceData);
      var jobs = [];

      var crewJobs = data.filter((s) => {
        return (
          s.itinerary &&
          s.itinerary.day_crew &&
          s.itinerary.day_crew._id == e._id
        );
      });
      if (crewJobs) {
        crewJobs.forEach((s) => {
          var t = this.eventTemplate(s);
          // console.log(t);
          jobs.push(t.template);
        });
      }

      var jobTable = "<table>";

      jobs.forEach((j) => {
        jobTable += "<tr><td>" + j + "</td></tr>";
      });
      jobTable += "</table>";
      const t = `        <div data-bgcolor="${eventColor}" data-forecolor="${this.$root.ajustColor(
        eventColor
      )}" class="event-template" style="color:${this.$root.ajustColor(
        eventColor
      )}" >
          <h3>  ${e.crew_name} </h3>
          <h3>${foreman}</h3>



${resources}
${jobTable}





        </div>`;

      ev = {
        _id: e._id,
        name: e.crew_name,
        start: start,

        color: eventColor,

        resources: e.resources,
        day_crew: e.day_crew,

        end: endTime,
        timed: false,
        template: t,
      };

      return ev;
    },
    eventTemplate: function(e, data, obj, unassigned) {
      // if (obj && obj.type == "week") {
      //   return this.crewTemplate(e, data, obj);
      // }

      var parent = fun.getParentByProperty(obj, "getLocation");
      if (e.agent && e.agent._id) {
        var agent = this.agent.find((a) => {
          return a._id == e.agent._id;
        });
        if (agent) {
          e.agent_id = agent._id;
        }
        if (!e.pickup_status) {
          // e.color = agent[0].color;
          e.pickup_status = "booked";
          // } else {
        }
      }
      try {
        e.color = this.status.filter((s) => {
          return s.status == e.pickup_status;
        })[0].color;
      } catch (error) {
        //
      }

      var eventColor = e.day_crew ? e.day_crew.color : "";
      if (e.customer) {
        var address = "",
          ev,
          serviceDate;
        // origin = parent.getLocation(e, "pickup");
        // destination = parent.getLocation(e, "dropoff");
        // if (origin) {
        // origin = origin.location.address;

        try {
          e.orig_city = e.origin.address.city;
          e.orig_state = e.origin.address.stateCode;
          var country =
            e.origin.address.countryCode == "USA"
              ? ""
              : e.origin.address.countryCode;
          address = e.orig_city || "" + ", " + e.orig_state || " " + country;
          if (e.customer) {
            e.first_name = e.customer.contact.first_name;
            e.last_name = e.customer.contact.last_name;
          }

          // e.customer_name = e.customer_name;
          // }
          // if (destination) {
          // destination = destination.location.address;
          e.dest_city = e.destination.address.city;
          e.dest_state = e.destination.address.stateCode;
          // address = e.dest_city + ", " + e.dest_state;
        } catch (error) {
          //
        }

        // }
      }

      var to = "";
      var from = "";
      var fromWhs = "";
      var toWhs = "";
      // if (e.destination && e.destination.address) {
      //   to = e.destination.address.city + " " + e.destination.address.state;
      // }
      if (!e.origin && e.stops) {
        e.origin = { address: {} };
        var p = e.stops.filter((s) => {
          return s.value == "pickup";
        });
        var origin = [];
        if (p.length) {
          p.forEach((a) => {
            origin.push(a.full_address);
          });
        }
        e.origin.address.text = origin.join();
      }
      if (!e.destination && e.stops) {
        e.destination = { address: {} };
        p = e.stops.filter((s) => {
          return s.value == "dropoff";
        });
        var destination = [];
        if (p.length) {
          p.forEach((a) => {
            destination.push(a.full_address);
          });
        }
        e.destination.address.text = destination.join();
      }
      try {
        from = e.origin.address.text;
        if (e.origin_address.isWarehouse) {
          fromWhs = "<span class='mdi mdi-warehouse'> </span>";
        }
      } catch (error) {
        //
      }
      try {
        to = e.destination.address.text;
        if (e.destination_address.isWarehouse) {
          toWhs = "<span class='mdi mdi-warehouse'> </span>";
        }
      } catch (error) {
        //
      }

      parent = fun.getParentByProperty(obj, "eventType");
      var serviceTypeAbbr = "";
      try {
        var st = e.service_type.split("_");
        st.forEach((s) => {
          serviceTypeAbbr += s.charAt(0).toUpperCase();
        });
      } catch (error) {
        // serviceTypeAbbr = e.service_type;
        //
      }

      serviceDate = new Date(e.service_date);
      if (obj && (obj.type == "week" || obj.type == "day")) {
        this.eventHeight = 250;
        if (obj.type == "week") {
          this.heightValue = "64vh";
        } else {
          this.heightValue = "inherit";
        }
      } else {
        this.eventHeight = 20;
        this.heightValue = "inherit";
      }
      // var statusColor = data.additional_model.itinerary_status.filter((a) => {
      //   return a.status == e.status;
      // });
      // if (statusColor.length) {
      //   eventColor = statusColor[0].color.slice(0, 7).trim();
      // }
      var start = new Date(serviceDate);

      var endTime = start.addHours(2);
      var foreman = e.foreman ? e.foreman.full_name : "";

      var customerName = e.customer_name;
      // ||
      // e.customer.contact.first_name + " " + e.customer.contact.last_name;
      var specialInstructions = e.special_instructions
        ? e.special_instructions
        : "";

      var shortInstructions =
        specialInstructions.substring(0, 300) +
        (specialInstructions.length > 300 ? "..." : "");

      // try {
      //   customerName =
      //     fun.getObjectsByKey(e, "first_name")[0] +
      //     " " +
      //     fun.getObjectsByKey(e, "last_name")[0];
      // } catch (error) {
      //   //
      // }
      var numMen = 0;
      var numTruck = 0;
      var resourceData = [];
      this.makeResourceTable(e, resourceData);

      var resources = this.makeResourceMap(resourceData);
      // if (e.resources) {
      //   var men = e.resources.filter((r) => {
      //     return r.resource_type == "mover";
      //   });

      //   var truck = e.resources.filter((r) => {
      //     return r.resource_type == "truck";
      //   });

      //   men.forEach((m) => {
      //     numMen += parseInt(m.qty);
      //   });
      //   truck.forEach((m) => {
      //     numTruck += parseInt(m.qty);
      //   });
      // }

      var weight = e.volume || "";
      var crew = "";
      if (e.day_crew) {
        crew = e.day_crew.crew_name;
      }
      var unassignedJob = "";
      if (unassigned) {
        unassignedJob = "<h4>unassigned</h4>";
      }
      function show(p) {
        return p ? "display:block" : "display:none";
      }

      const t = `        <div  class="event-template job"  >

${unassignedJob}

              <a href="javascript:openTab('${e._id}')">
                 <h3 class='event-title'> ${customerName} #${
        e.shipment_id
      }<br/> ${e.service_type}</h3></a>


${resources}


          <table><tr style=${show(from)}  >
            <td><span class="large-icon mdi mdi-arrow-left-circle"> </span>${fromWhs}</td>
            <td class='address'>  ${from}</td></tr>
         <tr  style=${show(to)} >
          <td><span class="large-icon mdi mdi-arrow-right-circle"> </span>${toWhs}</td>
          <td class='address'>  ${to}</td>
          </tr>
          </table>


        <span style=${show(
          weight
        )} class="mdi mdi-weight"> </span> ${weight}<br/>

                <div style=${show(
                  shortInstructions
                )} class="details tooltip-container">
        <span @click=openPopup('${
          e._id
        }') class="tooltip-trigger">${shortInstructions}</span>
        <a style="color:${this.$root.ajustColor(
          eventColor
        )}" href="javascript:openPopup('${
        e._id
      }')"><span class="large-icon mdi mdi-magnify"> </a><br/>

      </div>



        </div>`;
      // "<span class="tooltip-content">${specialInstructions}</span>"
      const unassignedContainer = `
        <div class="event-template"  data-bgcolor="#1C7B22" data-forecolor="#fff" >
          <table><tr><td> ${t} </td></tr></table
          </div>
        `;
      ev = {
        _id: e._id,
        name:
          e.shipment_id +
          " " +
          (serviceTypeAbbr || e.service_type) +
          " " +
          customerName +
          " " +
          address +
          foreman,
        start: serviceDate,
        shipment_id: e.shipment_id,
        first_name: fun.getObjectsByKey(e, "first_name")[0],
        last_name: fun.getObjectsByKey(e, "last_name")[0],
        agent_id: e.agent_id,
        itinerary: e.itinerary,
        color: eventColor,
        estimate_key: e.estimate_key,
        status: e.status,
        category: foreman,
        resources: e.resources,
        day_crew: e.day_crew,
        service_id: e._id,

        end: endTime,
        timed: obj && obj.type != "week",
        template: unassigned ? unassignedContainer : t,
      };

      return ev;
    },
    updateLdPickup(t, curRec) {
      var that = this;
      var model = {
        _id: t.item._id,
        pickup_status: t.item.pickup_status,
        foreman: t.item.foreman,
      };

      // var data = {
      //   metadata: that.data_object,
      //   model: model,
      // };
      // axios.post(this.serverURL + "/add_data", data, {
      //   withCredentials: true,
      // });

      if (curRec.itinerary && curRec.itinerary.length) {
        var itinerary = curRec.itinerary;
        itinerary[0] = t.item.itinerary;
        model.itinerary = itinerary;
        model.shipment_id = curRec.shipment_id;
        model.estimate_key = curRec.estimate_key;
        model.service_id = curRec.service_id;

        axios.post(this.serverURL + "/update_itinerary", model, {
          withCredentials: true,
        });
        // if (
        //   itinerary[0].agent._id != t.item.agent._id ||
        //   itinerary[0].warehouse._id != t.item.warehouse._id ||
        //   t.item.foreman
        // ) {
        //   itinerary[0].agent = t.item.agent;
        //   itinerary[0].warehouse = t.item.warehouse;
        //   if (t.item.foreman) {
        //     // if (!itinerary[0].crew) {
        //     //   itinerary[0].crew = {};
        //     // }
        //     itinerary[0].foreman = t.item.foreman;
        //   }

        // }
      }
    },
    getMonthlyCollectionName() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      return `calendar_data_${year}_${month}`;
    },
    getDataObject(tbl, calType, daily, dateFrame) {
      var pipeline = [];
      var object_name = "";
      var schema_name = "";
      if (dateFrame) {
        this.dateFrame = dateFrame;
      }

      object_name = daily ? "v_schedule_cal" : "v_schedule_cal_limited";
      if (this.customerQry || this.serviceQry) {
        object_name = "v_schedule_cal";
      }
      schema_name = "v_schedule_cal";

      var data_object = {
        object_name: object_name,
        daily: daily,

        date_fields: ["date"],
        mobileBreakpoint: 0,
        id_fields: ["agent_id"],
        // fields_excluded: ["route"],
        // get_table: "all",
        additional_data: [
          { obj_name: "service_type" },
          { obj_name: "service_category" },
          { obj_name: "vehicle_type" },
          { obj_name: "employee_role" },
          { obj_name: "itinerary_status" },
          { obj_name: "warehouse" },
          { obj_name: "agent" },
          { obj_name: "v_dispatcher" },
          { obj_name: "v_foreman" },
          { obj_name: "v_resource_type" },

          // { obj_name: "portal_settings" },
        ],
        additional_structure: [
          { obj_name: "employee", schema_name: "resource_crew" },
          { obj_name: "day_crew" },
        ],
        aggregate_variables: {},
        item_key: "shipment_id",
        table_title: "Shipments",
        hasSearch: true,
        // add_function: "update_customer_geo",
      };

      var agentQry =
        this.curAgent && this.curAgent._id
          ? { agent_id: this.curAgent._id }
          : {};
      var foremanQry = {};

      if (this.permittedActions) {
        this.permittedActions.forEach((a) => {
          if (
            a.filter_jobs &&
            !a.agent_jobs &&
            !this.$root.roles.some((role) => role.toLowerCase() === "admin")
          ) {
            if (this.isExternalDispatch) {
              //
              agentQry = {
                "shipment_detail.external_dispatcher._id": this.$root.user_id,
              };
            } else if (this.foremanFilter) {
              foremanQry = {
                "day_crew.crew_employee.employee._id": this.$root.user_id,
              };
            } else {
              agentQry = { "agent.email": this.currentUser };
            }
          }
          if (a.agent_jobs) {
            agentQry = { agent_id: null };
          }
        });
      }

      if (this.$root.filteredCompanies()) {
        if (!data_object.id_fields) {
          data_object.id_fields = [];
        }
        data_object.id_fields.push("_id");
        // var list_of_company_ids = this.$root.store.userData.company.map(
        //   (c) => c._id["$oid"]
        // );
        var filterCompanyQry = {
          "shipment_detail.company._id": {
            $in: this.$root.filteredCompanies(),
          },
        };
        if (!agentQry.$and) {
          agentQry.$and = [];
        }
        agentQry.$and.push(filterCompanyQry);
      }

      var qry = {};
      var dateQry = {};
      if (calType != "week") {
        qry = agentQry;
      }
      if (foremanQry) {
        qry = foremanQry;
      }

      if (this.customerQry && this.customerQry.customer_id) {
        qry = {
          ...qry,
          ...this.customerQry,
        };
      }
      if (this.serviceQry && this.serviceQry.service_category) {
        qry = {
          ...qry,
          ...this.serviceQry,
        };
      }

      data_object.qry = qry;
      data_object.dateQry = dateQry;
      data_object.qry_to_match = {};
      data_object.additional_data.push({
        obj_name: "v_day_crew",
        schema_name: "v_day_crew",

        qry: dateQry,
        date_fields: ["date"],
      });
      // var agentObj = { obj_name: "agent" };

      // data_object.additional_data.push(agentObj);
      return data_object;
    },

    onMarkerDrop(data, e, mapObject, toolTip) {
      var topElement = e
        .closest(".map-outer")
        .getElementsByClassName("map-top")[0];
      var innerElement = e
        .closest(".map-outer")
        .getElementsByClassName("map-inner")[0];
      const id = e.dataset.id;

      // if (data.crew_name && topElement.innerHTML == data.crew_name) {
      //   unassign = true;
      // }

      var modRec = this.mapData.find((d) => {
        return d._id == id;
      });
      let dayCrew = {
        _id: data._id,
        crew_name: data.crew_name,
        color: data.color,
      };
      modRec.day_crew = dayCrew;
      var jobCount = this.dataTable.filter((r) => {
        return r.itinerary.day_crew && r.itinerary.day_crew._id == data._id;
      }).length;

      var rec = this.dataTable.find((r) => {
        return r._id == id;
      });

      if (rec) {
        if (rec.day_crew) {
          toolTip.innerHTML = toolTip.innerHTML.replace(
            rec.day_crew.crew_name,
            dayCrew.crew_name
          );
        } else {
          toolTip.innerHTML += "<br/>" + "crew: " + dayCrew.crew_name;
        }
        const closeButton = toolTip.querySelector("button");
        closeButton.addEventListener("click", () => toolTip.remove());
        // rec.day_crew = dayCrew;
        let modRec = this.mapData.find((m) => {
          return m._id == id;
        });
        modRec.day_crew = dayCrew;
        this.$root.$emit("mapDataChanged", {
          data: this.mapData,
          legend: this.mapLegend,
          updateLegend: false,
          noRecenter: true,
        });
      }
      // data = {
      //   ...data,
      //   ...rec
      // };

      // this.updateTable({ item: rec }, resp => {
      //   // if (data.day_crew) {
      //   //   this.updateForemanOnMap(data, topElement);
      //   // }
      // });
      dayCrew.resources = data.resources.filter((r) => {
        return r.qty;
      });
      dayCrew.crew_employee = data.crew_employee;
      let updateData = [
        {
          update_fields: {
            day_crew: dayCrew,
            load_order: jobCount + 1,
          },
          _id: rec.sid,
          itinerary_id: rec.itinerary._id,
        },
      ];
      rec.itinerary.load_order = jobCount + 1;
      rec.itinerary.day_crew = dayCrew;
      this.resourceVBind.resources.find((r) => {
        return r._id == dayCrew._id;
      }).num_jobs += 1;
      axios
        .post(this.serverURL + "/update_crew", updateData, {
          withCredentials: true,
        })
        .then((r) => {});
    },
    updateForemanOnMap(data, topElement) {
      // var curForeman = this.day_crew.filter((f) => {
      //   return f._id == data.day_crew._id;
      // });
      // if (curForeman[0]) {
      topElement.innerHTML = data.day_crew.crew_name;
      // topElement.style.backgroundColor = curForeman[0].color;
      topElement.style.display = "block";
      // }
    },
    eventClick(e) {
      if (this.calType == "month" || this.calType == "day") {
        this.linkClick(e.event);
      }
      //
      // console.log(e);
    },
    getLocation(r, stopType) {
      try {
        var stops = r.stops;
        var st = stops.filter((s) => {
          return s.value == stopType;
        })[0];
        if (st) {
          var location = r.customer.address.filter((a) => {
            return a.full_address == st.full_address;
          })[0];
          if (location && location.location.address.geo) {
            location = location.location.address.geo;
          }
          return location;
        }
      } catch (error) {
        //
      }
    },
    createPickupMapData(r) {
      var serv = this.shipments.find((s) => {
        return s._id == r._id;
      });
      r = {
        ...r,
        ...serv,
      };
      if (serv && serv.day_crew) {
        try {
          serv.day_crew.color = this.dayCrews.find((c) => {
            return c._id == serv.day_crew._id;
          }).color;
        } catch {
          //
        }

        //
      }
      if (r.warehouse) {
        var whs = this.warehouse.filter((w) => {
          return w._id == r.warehouse._id;
        });
        if (
          whs.length &&
          !this.mapData.filter((m) => {
            return m.label == whs[0].warehouse_name;
          }).length
        ) {
          if (whs[0].geo && whs[0].address) {
            if (
              parseFloat(whs[0].geo.position[0]) &&
              parseFloat(whs[0].geo.position[1])
            )
              this.mapData.push({
                pos: {
                  lat: whs[0].geo.position[0],
                  lng: whs[0].geo.position[1],
                },
                label: whs[0].warehouse_name,
                address: whs[0].address.address,
                shortLabel: '<div class="mdi mdi-forklift"></div>',
                warehouseId: whs[0]._id,
                markerColor: whs[0].color,
                extraClass: ["square"],
              });
          }
        }
      }
      if (r.origin) {
        // var location = r.stops.filter((s) => {
        //   return s.value == "pickup";
        // });
        // if (location.length) {
        var topElementValue = "";
        var topElementColor = "";
        var orig = r.origin;
        var path = ["location", "address", "geo", "location", "position"];
        var pos = orig.position;
        if (!pos && r.route && r.route.stops) {
          var origin_adress = "";
          try {
            origin_adress = r.origin.address.text;
          } catch {
            //
          }
          pos = r.route.stops.find((s) => {
            return s.full_address == origin_adress;
          });
          if (pos) {
            pos = pos.position;
          }
        }
        if (!pos) {
          pos = [0, 0];
        }
        // if (pos && parseFloat(pos[0]) && parseFloat(pos[1])) {
        var label = ` <a href=javascript:openTab('${r._id}')
            ><b>${r.customer_name} #${r.shipment_id}</b></a><br/>${r.special_instructions}`;

        if (r.delivery_date_range) {
          label += "<br>Delivery Dates:<br>" + r.delivery_date_range;
        }

        var time = fun.formatTime(r.date);
        var shortLabel = time;
        if (r.day_crew) {
          // var curForeman = this.foreman.filter((f) => {
          //   return f._id == r.foreman._id;
          // });
          // if (curForeman[0]) {
          topElementValue = r.day_crew.crew_name;
          label += "<br/>crew: " + r.day_crew.crew_name;
          // topElementColor = curForeman[0].color;
          // }
        }

        var markerColor = whs && whs[0] ? whs[0].color : "green";
        var color = fun.randomColor();
        var service = r;
        r.shape = r.route_shape;
        // r.waypoint[(r.origin.position, r.destination.position)];
        if (
          r.stops &&
          r.route &&
          r.route.waypoint &&
          r.route.waypoint.length < r.stops.length
        ) {
          console.log(r.stops);
        }

        this.mapData.push({
          mapLine: {
            service: {
              route: r.route,
            },
          },

          pos: {
            lat: pos[0],
            lng: pos[1],
          },
          whs: r.warehouse,
          label: label,
          address: orig.full_address,
          shortLabel: shortLabel,
          markerColor: markerColor,
          color: color,
          day_crew: r.day_crew,
          shipment_id: r.shipment_id,
          first_name: r.customer.contact ? r.customer.contact.first_name : "",
          last_name: r.customer.contact ? r.customer.contact.last_name : "",
          topElementValue: topElementValue,
          topElementColor: topElementColor,
          _id: r._id,
        });
        // }
        // }
      }
      // console.log(this.mapData);
    },
    filterAgent(item) {
      if (this.$refs.calTblMap) {
        // this.$refs.calTblMap.tableData
        this.$refs.calTblMap.refresh({
          item: item.agent,
          object_name: "agent",
        });
      }

      var curData = this.dataTable;
      if (this.curAgent) {
        curData = this.dataTable.filter((t) => {
          return t.agent && t.agent._id == this.curAgent._id;
        });
      }
      try {
        this.$refs.calTblMap.tableData = curData;
      } catch (error) {
        //
      }

      this.mapData = [];
      curData.forEach((r) => {
        this.createPickupMapData(r);
      });
      this.fullMapData = fun.clone(this.mapData);
      this.$root.$emit("mapDataChanged", {
        data: this.mapData,
        legend: this.mapLegend,
      });
    },
    getDispatcherAgents() {
      if (this.permittedActions.includes("agent_jobs")) {
        this.curDispatcher = this.dispatcher.filter((r) => {
          return r.email == this.currentUser;
        })[0];
        if (this.curDispatcher) {
          this.filterTabs = [];
          this.agentCombo.objName = "v_employee_agents";
          this.agentCombo.qry = { email: this.currentUser };
          this.toolBarControls[1]["v-bind"].objName = "v_employee_agents";
          this.toolBarControls[1]["v-bind"].qry = { email: this.currentUser };
          this.toolBarControls.splice(2);
          this.calToolBarControls = [];
          // this.toolBarControls[2] = {};

          //
        }
        var cal = this.$refs.calTblMap;
        // this.agentComboKey = !this.agentComboKey;
        // console.log(cal.calToolBarControls);
        // cal.calToolBarControls[0].key = !this.agentComboKey;
        // cal.calKey = !cal.calKey;
      }
    },
    prepareResources(data, d) {
      var that = this;
      this.mapLegend.mapDate = fun.convertDateFormat(
        fun.formatDate(d, false, false, true)
      );
      this.resourceVBind.data = this.dataTable;
      // .map(
      //   ({ customer, ...rest }) => rest
      // );

      this.objCal.calModel = fun.formatDate(d, true, false, true);
      this.resourceVBind.getRowClass = this.getRowClass;
      fun.sortObjects(data.additional_model.v_day_crew, "crew_name");
      this.resourceVBind.resources = data.additional_model.v_day_crew;

      this.resourceVBind.d = d;
      this.resourceVBind.data.forEach((r) => {
        console.log(r);
      });
      this.resourceVBind.resources.forEach((resource) => {
        // Count the number of jobs associated with this resource
        // console.log(resource.crew_name, resource._id);
        resource.num_jobs = this.resourceVBind.data.filter(
          (record) => record.day_crew && record.day_crew._id === resource._id
        ).length;
      });

      this.resourceVBind.resourceSchema = data.additional_structure.day_crew;
      this.resourceVBind.resourceSchema["v-bind"] = {
        ...this.resourceVBind.resourceSchema["v-bind"],
        ...{
          droppedObjectsSortProperty: "itinerary.load_order",
          dropItemHandling: function(crew, droppedItem, index, tbl) {
            // Get the filtered and sorted list of items

            let data = [];

            if (
              tbl.draggedIndex != undefined &&
              droppedItem.itinerary &&
              crew._id == droppedItem.day_crew._id
              //  ||
              //   crew._id == droppedItem.itinerary.day_crew._id)
            ) {
              //dragged from unassigned jobs
              that.updatedItems = that.dataTable
                .filter((r) => {
                  return r.day_crew && r.day_crew._id == crew._id;
                })
                .sort(
                  (a, b) => a.itinerary.load_order - b.itinerary.load_order
                );
              // const draggedItem = that.updatedItems[tbl.draggedIndex];
              droppedItem = that.dataTable.find((t) => {
                return t._id == droppedItem._id;
              });

              let currentLoadOrder = droppedItem.itinerary.load_order;
              let newLoadOrder = index + 1;
              let dir = "";
              if (newLoadOrder < currentLoadOrder) {
                // moved left
                dir = "left";
              } else {
                dir = "rignt";
              }

              droppedItem.itinerary.load_order = newLoadOrder;
              that.updatedItems.forEach((obj, idx) => {
                if (obj._id != droppedItem._id)
                  if (dir == "left") {
                    if (obj.itinerary.load_order >= newLoadOrder) {
                      if (obj.itinerary.load_order < currentLoadOrder) {
                        obj.itinerary.load_order += 1; // Assign a new load_order starting from 1
                      }
                    }
                  } else {
                    if (
                      obj.itinerary.load_order <= newLoadOrder &&
                      obj.itinerary.load_order > 1
                    ) {
                      obj.itinerary.load_order -= 1; // Assign a new load_order starting from 1
                    }
                  }
              });
              2;
              tbl.draggedIndex = null;
              that.updatedItems.forEach((j, i) => {
                var shipment = that.shipments.find((s) => {
                  return s.itinerary._id == j.itinerary._id;
                });
                data.push({
                  _id: shipment.sid,
                  itinerary_id: j.itinerary._id,
                  update_fields: {
                    load_order: j.itinerary.load_order,
                  },
                });
              });
            } else {
              var updatedItem = that.dataTable.filter((r) => {
                return (
                  r.itinerary && r.itinerary._id == droppedItem.itinerary._id
                );
              })[0];
              updatedItem.day_crew = {
                _id: crew._id,
                crew_name: crew.crew_name,
                resources: crew.resources.filter((r) => {
                  return r.qty;
                }),
                crew_employee: crew.crew_employee,
              };
              that.resourceVBind.data.find((d) => {
                return d._id == updatedItem._id;
              }).day_crew = updatedItem.day_crew;
              updatedItem.itinerary.load_order = that.dataTable.filter((r) => {
                return r.day_crew && r.day_crew._id == crew._id;
              }).length;

              tbl.droppedObjects.push(updatedItem);
              data.push({
                update_fields: {
                  day_crew: updatedItem.day_crew,
                  load_order: updatedItem.itinerary.load_order,
                },
                _id: droppedItem.sid,
                itinerary_id: droppedItem.itinerary._id,
              });
            }
            var res = that.resourceVBind.resources.find((r) => {
              return r._id == crew._id;
            });
            if (res) {
              res.num_jobs += 1;
            }
            tbl.dropKey = !tbl.dropKey;
            axios
              .post(this.serverURL + "/update_crew", data, {
                withCredentials: true,
              })
              .then((r) => {});
          },
        },
      };
      // this.resourceVBind.editData = data.additional_model.v_day_crew;
      this.resourceVBind.additionalModel = {
        vehicle_type: data.additional_model.vehicle_type,
        employee_role: data.additional_model.employee_role,
      };
      this.resourceVBind.getQry = function(res) {
        return { date: res.d };
      };
      fun.sortObjects(this.resourceVBind.data, "load_order");
      try {
        this.resourceVBind.data.sort((a, b) => {
          return b.itinerary.load_order > a.itinerary.load_order;
        });
      } catch (error) {
        //
      }

      // this.resourceVBind.resources = data.additional_model.v_foreman;
      // this.resourceVBind.resourceSchema =
      //   data.additional_structure.resource_crew;
      this.resourceVBind.update = this.doAssign;
      this.resourceVBind.addDefaultResources = function(res) {
        if (!res.defaultResources.length) {
          res.d = fun.formatDate(d, false, false, true);
          res.defaultResources = [];
          that.resourceVBind.additionalModel.vehicle_type
            .filter((t) => {
              return t.default;
            })
            .forEach((t) => {
              res.defaultResources.push({
                resource_type: t.vehicle_type,
                resource_category: "vehicle",
              });
            });
          that.resourceVBind.additionalModel.employee_role
            .filter((t) => {
              return t.default;
            })
            .forEach((t) => {
              res.defaultResources.push({
                resource_type: t.employee_role,
                resource_category: "labor",
              });
            });
        }
      };
      if (this.objCal) {
        this.objCal.resourceKey = !this.objCal.resourceKey;
      }
    },
    onDataReceived(data, d, obj, showTable, fromScroll) {
      // console.log(data);
      this.calType = obj;
      if (!data.model) {
        return;
      }
      var that = this;
      // this.dayCrews = data.additional_model.day_crew;
      this.mapData = [];
      this.mapReady = false;
      this.foreman = data.additional_model.v_foreman;
      this.serviceCategory = data.additional_model.service_category;
      this.serviceType = data.additional_model.service_type;
      this.resourceType = data.additional_model.v_resource_type;
      this.status = data.additional_model.itinerary_status;
      this.warehouse = data.additional_model.warehouse;
      this.agent = data.additional_model.agent;
      this.dispatcher = data.additional_model.v_dispatcher;
      if (!fromScroll) {
        this.dayCrews = data.additional_model.v_day_crew;
      }

      // if (this.agent.length == 1) {
      //   this.curAgent = this.agent[0];
      // }
      if (!fromScroll) {
        this.shipments = data.model;
      } else {
        this.shipments = fun.mergeArrays(this.shipments, data.model, "_id");
      }

      var v = this.curAgent;
      data.events = [];
      if (obj != "week") {
        this.dataTable = data.model;

        this.dataTable.forEach((d) => {
          var service = d.booked_service;
          if (service && service.itinerary && service.itinerary.length) {
            d.day_crew = service.itinerary[0].day_crew;
          }
          if (d.service_date) {
            d.service_date = fun.formatDate(d.service_date, false);
            var dd = d.service_date.split(" ");
            // dd[1] = "08:00";
            var ddd = [];
            ddd.push(dd[0]);
            ddd.push("08:00");

            d.service_date = ddd.join(" ");
            var ev = this.eventTemplate(d, data, obj);
            ev.more = d.more;
            if (ev && ev.start) {
              data.events.push(ev);
            }
          }

          // d.service_date;
        });

        this.dataTable.sort((a, b) => {
          const crewA = a.day_crew?.crew_name || ""; // Use an empty string for null
          const crewB = b.day_crew?.crew_name || ""; // Use an empty string for null

          // Compare the crew names alphabetically
          return crewA.localeCompare(crewB);
        });
      } else {
        this.dataTable = data.additional_model.v_day_crew;
        if (this.customerQry) {
          this.dataTable = this.dataTable.filter((dataItem) => {
            return this.shipments.some((shipment) => {
              // Check if day_crew exists and if its _id matches the dataItem's _id
              return (
                shipment.day_crew && shipment.day_crew._id === dataItem._id
              );
            });
          });
        }

        var customerFilterCombo = this.calToolBarControls.find((c) => {
          return c.id == "customer_filter";
        });
        var serviceTypeFilterCombo = this.calToolBarControls.find((c) => {
          return c.id == "service_filter";
        });
        serviceTypeFilterCombo["v-bind"].items = this.serviceCategory;
        this.$nextTick(() => {
          this.objCal.$refs.service_filter[0].comboItems = this.serviceCategory;
        });
        this.objCal = this.$refs.calTblMap;
        var customers = [];
        if (!this.customerQry) {
          this.shipments.forEach((s) => {
            if (s.unique_customers) {
              s.unique_customers.forEach((c) => {
                if (
                  !customers.some((r) => {
                    return r.customer == c.customer;
                  })
                ) {
                  customers.push(c);
                }
              });
            } else if (s.customer) {
              if (
                !customers.some((r) => {
                  return r.customer == s.customer._id;
                })
              ) {
                customers.push({
                  customer: s.customer._id,
                  customer_name: s.customer_name,
                });
              }
            }
          });
          console.log(customers.length);
          fun.sortObjects(customers, "customer_name");
          customerFilterCombo["v-bind"].items = customers;
          this.$nextTick(() => {
            this.objCal.$refs.customer_filter[0].comboItems = customers;
          });
        }

        this.dataTable.forEach((e, i) => {
          if (data.model.length) {
            var ev = this.crewTemplate(e, data.model, i);
            data.events.push(ev);
          }
        });
        var unassignedJobs = data.model.filter((s) => {
          return !s.itinerary || !s.itinerary.day_crew;
        });
        unassignedJobs.forEach((j) => {
          var unassignedJob = this.eventTemplate(j, null, null, true);
          data.events.push(unassignedJob);
        });
      }

      if (d) {
        if (this.objCal) {
          // this.objCal.dayClick(d, true, data.model);
          // this.getGeo();
          this.objCal.mapReady = true;
          this.objCal.mapLoading = false;
          this.mapLegend.editData = this.dayCrews;
        }

        var serviceDate = fun.formatDate(d);
        this.dataTable = data.model.filter((m) => {
          return fun.formatDate(new Date(m.service_date)) == serviceDate;
        });

        this.$root.$emit("mapDataChanged", {
          data: this.mapData,
          legend: this.mapLegend,
        });
        this.mapReady = true;
        this.prepareResources(data, d);
        if (this.showCrews && this.objCal) {
          this.showCrews = false;
          this.objCal.activeTab = 3;
          this.objCal.dayClicked = true;
          this.objCal.tableData = this.dataTable;
          this.objCal.data_object.schema = data.schema;
          this.objCal.tableReady = true;
          return false;
        }
        if (showTable) {
          return this.dataTable;
        } else {
          return data;
        }
      } else {
        if (!v || !v.length) {
          if (this.permittedActions) {
            this.permittedActions.forEach((p) => {
              if (p.filter_jobs) {
                this.calToolBarControls[0].hidden = true;
              }
            });
          } else {
            this.calToolBarControls[0].hidden = false;
            this.toolBarControls[0].hidden = false;
            // return data.model.filter((m) => {
            //   return !m.agent;
            // });
          }
        } else {
          this.toolBarControls[0].hidden = true;
        }
        this.getDispatcherAgents();
        // , this.toolBarControls;
        if (data.additional_model.v_foreman) {
          data.additional_model.v_foreman.forEach((f) => {
            if (!f.crew) {
              f.crew = { crew: [], truck: [] };
            }
          });
        }

        return data;
      }
    },
    getGeo() {
      var that = this;
      const result = this.shipments.map((item) => ({
        _id: item._id,
        sid: item.sid,
        has_route: item.has_route,
        customerId: item.customer ? item.customer._id : null, // Safely handle if customer is undefined
        stops: item.stops || [], // Default to an empty array if stops is undefined
      }));
      if (that.objCal) {
        that.objCal.mapReady = true;
        that.objCal.mapLoading = true;
      }
      // Send the list to the backend

      axios
        .post(this.serverURL + "/apply_geo_data", result, {
          withCredentials: true,
        })
        .then((response) => {
          console.log("Response from backend:", response.data);
          response.data.forEach((r) => {
            this.createPickupMapData(r);
          });
          this.mapLegend.editData = this.dayCrews;

          this.$root.$emit("mapDataChanged", {
            data: this.mapData,
            legend: this.mapLegend,
            updateLegend: false,
          });
          if (that.objCal) {
            that.objCal.mapReady = true;
            that.objCal.mapLoading = false;
          }
        })
        .catch((error) => {
          console.error("Error sending data to backend:", error);
        });
    },
    replaceColor(obj) {
      var classes = "";
      if (obj) {
        obj.forEach((s) => {
          try {
            if (s.color && s.color.replace) {
              if (s.color.length == 9 && s.color[0] == "#") {
                s.color = s.color.substr(0, 7);
              }
              var className = "color-" + s.color.replace("#", "");
              var classCss =
                "background-color:" +
                s.color +
                "; color:" +
                this.$root.ajustColor(s.color);
              // fun.invertColor(s.color);
              var cl = "\n." + className + " { " + classCss + "}";
              if (classes.indexOf(cl) == -1) {
                classes += cl;
              }
            }
          } catch (error) {
            console.log(error);
          }
        });
        this.$root.dynamicClasses(classes);
      }
    },
    calendarFilter(cal) {
      if (this.curAgent && cal.originalEvents) {
        return cal.originalEvents.filter((r) => {
          r.agent && r.agent._id == this.curAgent._id;
        });
      } else {
        return cal.originalEvents;
      }
    },
  },
  watch: {
    // unassignedOnly() {
    //   this.toolBarControls[0].hidden = !this.unassignedOnly;
    // },
    // table: {
    //   handler: function(oldValue, newValue) {
    //     this.toolBarControls[1].hidden = !this.table.selected.length;
    //   },
    //   deep: true,
    // },
    calModel() {
      var cal = this.$refs.calTblMap.$refs.calendar;
      if (this.calModel && this.calModel != this.model) {
        cal.model = this.calModel;
        cal.refresh = true;
      }
    },
    heightValue(newValue) {
      document.documentElement.style.setProperty(
        "--calendar-height",
        `${newValue}`
      );
    },
    curAgent() {
      // if (this.curAgent) {
      var cal = this.$refs.calTblMap;
      this.getDataObject();
      if (!this.curAgent && !cal.dayClicked) {
        cal.tableReady = false;
        cal.activeTab = 0;
      } else {
        cal.tableReady = true; // this.curAgent || (cal.activeTab && cal.dayClicked);
      }

      // this.filterAgent();
    },
  },
  computed: {},
};
</script>

<style lang="css">
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.special-instructions {
  /* max-height: 200px;
  padding: 5px;
  overflow: auto; */
}
.tooltip-content {
  visibility: hidden;
  opacity: 0;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  position: absolute;
  z-index: 1000;
  bottom: 0;
  /* Position above the trigger */
  left: 0;
  /* transform: translateX(-50%); */
  transition: opacity 0.3s ease, visibility 0.3s ease;
  white-space: normal;
  /* Allow wrapping */
  width: 100%;
  /* Prevent exceeding container width */
  word-wrap: break-word;
  /* Break long words if necessary */
  overflow-wrap: break-word;
  /* Compatibility for breaking words */
  max-height: 150px;
  /* Limit the height */
  overflow-y: auto;
  /* Add vertical scrolling */
}

.tooltip-container:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
}

.popup-instructions {
  color: black;
}
.job {
  /* border: solid 1px; */
  padding: 10px;

  /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
.drop-zone .job {
  min-width: 300px;
  height: 150px;
  overflow: auto;
}

.large-icon {
  font-size: 24px;
  padding: 5px;
}

.unassigned-count {
  color: red;
}

.v-calendar-daily_head-day {
  height: var(--calendar-height, "inherit");
  overflow-y: auto;
}

.resource-table table {
  width: 100%;
  border-collapse: collapse;
}

.resource-table th,
.resource-table td {
  border: 1px solid #ddd;
  /* padding: 8px; */
  text-align: center;
  /* Align all text in the cells to the center */
}

.resource-table th {
  /* background-color: #f2f2f2; */
}

.details {
  white-space: normal;
  /* Allow the text to wrap */
  word-wrap: break-word;
  /* Break long words if they are too wide */
  overflow: hidden;
  /* Hide overflow if any */
}

.v-event {
  height: auto !important;
}
.team-header {
  font-size: 10px !important;
}

.reserved-cell {
  color: red;
  background-color: white;
}

.event-title {
  text-align: center;
  text-transform: uppercase;
  background-color: white;

  white-space: normal;
  /* Allow the text to wrap */
  word-wrap: break-word;
  /* Break long words if they are too wide */
  overflow: hidden;
  /* Hide overflow if any */
}

.address {
  /* display: inline-block; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
